import { Component, Injectable, NgModule } from '@angular/core';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-bootstrap/modal';
class NgxBootstrapConfirmComponent {
    constructor(bsModalRef) {
        this.bsModalRef = bsModalRef;
    }
    ngOnInit() {
        this.onClose = new Subject();
    }
    confirm() {
        this.onClose.next(true);
        this.bsModalRef.hide();
    }
    decline() {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }
}
NgxBootstrapConfirmComponent.ɵfac = function NgxBootstrapConfirmComponent_Factory(t) { return new (t || NgxBootstrapConfirmComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BsModalRef)); };
NgxBootstrapConfirmComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxBootstrapConfirmComponent, selectors: [["lib-ngx-bootstrap-confirm"]], decls: 5, vars: 3, consts: [[1, "confirm", "modal-body"], [1, "content", 3, "innerHTML"], [1, "buttons"], ["type", "button", 1, "btn", "btn-success", 3, "innerHTML", "click"], ["type", "button", 1, "btn", "btn-danger", 3, "innerHTML", "click"]], template: function NgxBootstrapConfirmComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function NgxBootstrapConfirmComponent_Template_button_click_3_listener() { return ctx.confirm(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵlistener("click", function NgxBootstrapConfirmComponent_Template_button_click_4_listener() { return ctx.decline(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.title, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.confirmLabel, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.declineLabel, ɵngcc0.ɵɵsanitizeHtml);
    } }, encapsulation: 2 });
NgxBootstrapConfirmComponent.ctorParameters = () => [
    { type: BsModalRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxBootstrapConfirmComponent, [{
        type: Component,
        args: [{
                selector: 'lib-ngx-bootstrap-confirm',
                template: `
  <div class="confirm modal-body">
      <div class="content" [innerHTML]="title"></div>
      <div class="buttons">
          <button type="button" class="btn btn-success" (click)="confirm()" [innerHTML]="confirmLabel"></button>
          <button type="button" class="btn btn-danger" (click)="decline()" [innerHTML]="declineLabel"></button>
      </div>
  </div>
  `
            }]
    }], function () { return [{ type: ɵngcc1.BsModalRef }]; }, null); })();

class NgxBootstrapConfirmService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    confirm(options) {
        return new Promise((resolve, reject) => {
            this.modalRef = this.modalService.show(NgxBootstrapConfirmComponent);
            this.modalRef.content.title = options.title;
            this.modalRef.content.confirmLabel = options.confirmLabel;
            this.modalRef.content.declineLabel = options.declineLabel;
            this.modalRef.content.onClose.subscribe((result) => {
                resolve(result);
            });
        });
    }
}
NgxBootstrapConfirmService.ɵfac = function NgxBootstrapConfirmService_Factory(t) { return new (t || NgxBootstrapConfirmService)(ɵngcc0.ɵɵinject(ɵngcc1.BsModalService)); };
NgxBootstrapConfirmService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxBootstrapConfirmService, factory: NgxBootstrapConfirmService.ɵfac });
NgxBootstrapConfirmService.ctorParameters = () => [
    { type: BsModalService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxBootstrapConfirmService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.BsModalService }]; }, null); })();

class NgxBootstrapConfirmModule {
}
NgxBootstrapConfirmModule.ɵfac = function NgxBootstrapConfirmModule_Factory(t) { return new (t || NgxBootstrapConfirmModule)(); };
NgxBootstrapConfirmModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxBootstrapConfirmModule });
NgxBootstrapConfirmModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [NgxBootstrapConfirmService], imports: [[ModalModule.forRoot()]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxBootstrapConfirmModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxBootstrapConfirmComponent],
                imports: [ModalModule.forRoot()],
                exports: [NgxBootstrapConfirmComponent],
                providers: [NgxBootstrapConfirmService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxBootstrapConfirmModule, { declarations: [NgxBootstrapConfirmComponent], imports: [ɵngcc1.ModalModule], exports: [NgxBootstrapConfirmComponent] }); })();

/*
 * Public API Surface of ngx-bootstrap-confirm
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxBootstrapConfirmComponent, NgxBootstrapConfirmModule, NgxBootstrapConfirmService };

//# sourceMappingURL=ngx-bootstrap-confirm.js.map